module.exports = __webpack_public_path__ + "static/media/icon-file-pdf.c5b21da3f0d0df109bd8783d4830c83f.svg";